export default __webpack_public_path__ + "images/153a718e61ea65f0535a369e67e9130c-nonprofitandngos_small.webp";